import React from "react";
import styled from "styled-components";
import toNumber from "lodash/toNumber";
import round from "lodash/round";
import get from "lodash/get";
import UISlider from "components/Slider";
import { useUsersCountry } from "lib/QuizContext";
import { formatCurrency } from "lib/format";
import { size } from "lodash";

const Text = styled.div`
  margin-bottom: 3rem;
  font-size: 3rem;
  font-weight: bold;
  color: ${(props) => {
    if (!props.isDirty) return "#999";
    return props.isThreshold ? "#ff0000" : "#000";
  }};
  text-align: center;
  transition: color 0.2s ease;

  @media (min-width: 768px) {
    font-size: 4rem;
  }
`;

const InfoText = styled.p`
  color: #999999;
  font-size: 2rem;
  text-align: center;
`;

const WarningText = styled.p`
  color: #ff0000;
  font-size: 2rem;
  text-align: center;
`;

const Spacer = styled.div`
  display: block;
  min-height: 28px;
`;

const Contract = (props) => {
  const country = useUsersCountry();

  const max = toNumber(get(props, country, 5));

  const handleChange = (value) => {
    const { id, type, isWeighted = true } = props;

    props.dispatch({
      type: "CHANGE_ANSWER",
      answer: { id, type, value, isWeighted },
      multiChoice: props.multiChoice,
    });
  };

  const value = getValue(props, round(max * 0.6));

  const plusSymbol = value === max ? "+" : "";

  const isDirty = size(props.answer) > 0;

  return (
    <React.Fragment>
      <Text isDirty={isDirty}>
        {formatCurrency(value, country)}
        {plusSymbol}
      </Text>
      <UISlider
        onChange={handleChange}
        max={max}
        value={value}
        isBudget
        country={country}
      />
      {!isDirty ? (
        <InfoText>
          {props.noBudget
            ? 'Drag slider to select a budget, or select "no budget"'
            : "Drag slider to select a budget"}
        </InfoText>
      ) : (
        <Spacer />
      )}
    </React.Fragment>
  );
};

export default Contract;

function getValue(props, defaultValue) {
  const answer = props.answer.find((a) => a.id === props.id);
  return answer ? answer.value : defaultValue;
}
